import { Grid, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

interface Props {
  total: number
  current: number
  pageSize: number
  onChange: (page: number, perPage: number) => void
  showSizeChanger?: boolean
  mb?: number
  cursor?: string
  cursorPrev?: string
  onCursorChange?: (cursor: string | undefined, isPrev: boolean) => void
}

const PaginationButton = (props: Props) => {
  const {
    total = 0,
    current = 1,
    pageSize = 10,
    onChange,
    showSizeChanger = true,
    mb = 0,
    cursor,
    cursorPrev,
    onCursorChange,
  } = props

  const handlePrevious = () => {
    if (cursorPrev && onCursorChange) {
      onCursorChange(cursorPrev, true)
    }
  }

  const handleNext = () => {
    if (cursor && onCursorChange) {
      onCursorChange(cursor, false)
    }
  }

  return (
    <Grid
      container
      mt={1}
      spacing={2}
      alignItems={'center'}
      justifyContent={'center'}
      mb={mb}
    >
      <Grid item>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handlePrevious}
          disabled={!cursorPrev}
        >
          Previous
        </Button>
      </Grid>
      <Grid item>
        <Button
          endIcon={<ArrowForwardIcon />}
          onClick={handleNext}
          disabled={!cursor}
        >
          Next
        </Button>
      </Grid>
    </Grid>
  )
}

export default PaginationButton
